import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"icon-back\">\n<path d=\"M8.4,15.3h17c0.4,0,0.8,0.3,0.8,0.8c0,0.4-0.3,0.8-0.8,0.8h-17c-0.4,0-0.8-0.3-0.8-0.8C7.6,15.6,8,15.3,8.4,15.3z\" />\n<path d=\"M6,15.4l6.2-5.2c0.3-0.3,0.8-0.2,1.1,0.1s0.2,0.8-0.1,1.1L7,16.6c-0.3,0.3-0.8,0.2-1.1-0.1S5.7,15.7,6,15.4z\" />\n<path d=\"M6,16.7l6.2,5.2c0.3,0.3,0.8,0.2,1.1-0.1s0.2-0.8-0.1-1.1L7,15.5c-0.3-0.3-0.8-0.2-1.1,0.1S5.7,16.4,6,16.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol